import { camelCase, isObject } from "lodash";

/**
 * camelCases our API responses so that we can use them in accordance with our linting rules
 *
 * @param {any} obj an API response
 *
 */
export function prepareForApp(obj: any): any {
  if (
    typeof obj === "string" ||
    typeof obj === "number" ||
    typeof obj === "boolean" ||
    obj === null
  ) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(prepareForApp);
  }

  const output = {};
  const keys = Object.keys(obj);

  /* tslint:disable */
  for (let i = 0; i < keys.length; i++) {
    /* tslint:enable */

    const key = keys[i];
    const k = camelCase(key);

    if (Array.isArray(obj[key])) {
      output[k] = obj[key].map(prepareForApp);
    } else if (isObject(obj[key])) {
      output[k] = prepareForApp(obj[key]);
    } else {
      output[k] = obj[key];
    }
  }
  return output;
}
